<template>
  <v-card>
    <v-tabs :value="promoFactTab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchPromotionFactors()">Factors</v-tab>
      <v-tab v-show="displayFactReviewTab" @click="reviewPromotionFactor()">Factor Info and Rates</v-tab>
      <v-tab v-show="displayRateTab">Rate Info</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayFactReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayRateTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { PROMOTION_PROMOFACT_TABMENU } from '@/store/types'

export default {
  data() {
    return {
    }
  },
  computed: {
    promoFactTab() {
      return this.$store.state.promotionManagement.promotion.promoFactorTabMenu
    },
    displayFactReviewTab() {
      return this.$store.state.promotionManagement.promotion.promoFactorDisplayFactReviewTab
    },
    displayRateTab() {
      return this.$store.state.promotionManagement.promotion.promoFactorDisplayRateTab
    },
    promoFactorProduct() {
      return this.$store.state.promotionManagement.promotion.promoFactorProduct
    }
  },
  methods: {
    fetchPromotionFactors() {
      const commitData = {
        promoFactTab: 0,
        displayFactReviewTab: false,
        displayRateTab: false
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'promotionFactors', params: { promotion: this.promotion } })
    },
    reviewPromotionFactor() {
      const commitData = {
        promoFactTab: 1,
        displayFactReviewTab: true,
        displayRateTab: false
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'factorReview', params: { product: this.promoFactorProduct } })
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchPromotionFactors()
  }
}
</script>

<style lang="scss">
</style>
